<template>
  <div class="device014_dimming_wraper device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name z_ellipsis1">{{objData.remark}}</div>

    <div class="content022_wraper content014_wraper content027_wraper">
      <div class="device022_time_title">定时触发时间</div>
      <div class="device_022_time">{{computedShowTime}}</div>

      <div class="device_022_scene">
        <span>重复：</span>
        <span class="device_022_text_width z_ellipsis1">{{computerCycleConfigShow}}</span>
      </div>

      <div class="device_022_scene">
        <span>触发场景：</span>
        <span class="device_022_text_width z_ellipsis1">{{ServeOneObjectinfo.businessId4Desc}}</span>
      </div>

      <div
        class="device022_btn device_control_btn public_control_btn"
        :class="userControlData.openState? 'public_control_btn_on':''"
        @click="device022BtnClickHandle"
      >{{deviceStateComputed}}</div>
    </div>

    <!-- <BUtton @click="btnhandle">按钮</BUtton> -->
  </div>
</template>

<script>
///需要注意的是  调光进度条和 按钮之间的翻转逻辑 进度条大于0 按钮显示已打开 小于等于0显示 已关闭 。操作按钮打开 进度条100 关闭 进度条0
import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
// import ProgressBar from "components/common/progressbar/progress-bar";
export default {
  data() {
    return {
      userControlData: {
        ///用户设置的缓冲数据
        openState: this.objData.openState, ///1开定时 或0关定时
        openStateValue: this.objData.openStateValue, //无用
        openStateValue1: this.objData.openStateValue1, ///无用
        openStateValue2: this.objData.openStateValue2 ///无用
      }
    };
  },
  props: {
    objData: Object, ///要控制设备的数据
    ServeOneObjectinfo: Object ////要展示的数据
  },
  components: {
    // ProgressBar
  },
  methods: {
    device022BtnClickHandle() {
      ///按钮按下
      deviceStateFlip(this.userControlData); ///对设备的状态0和1进行翻转
      // if (this.userControlData.openState === 1) {
      //   this.userControlData.openState = 0;
      // } else {
      //   this.userControlData.openState = 1;
      // }

      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    }
  },
  computed: {
    computedShowTime() {
      let serveHour = ""
      let serveMin = ""
      ///显示时间补位
      if (this.ServeOneObjectinfo.businessId2.indexOf(":") != -1) { /// ///说明包含：这个字符串
        ///处理拿到的时间
        serveHour = this.ServeOneObjectinfo.businessId2.match(/(\S*):/)[1]; ////拿到时间之后  取出：之前的小时 取字符串
        serveMin = this.ServeOneObjectinfo.businessId2.match(/:(\S*)/)[1]; ////拿到时间之后  取出：之后的分钟 取字符串
        if (serveMin.length < 2) {
          // 分钟需要补0
          serveMin = String("0" + serveMin);
          return String(serveHour + ":"  + serveMin);
        } else {
          return this.ServeOneObjectinfo.businessId2;
        }
      }else{
        ///说明字符串是不合法的
        console.log("定时时间字符串不合法")
        serveHour = "" ////拿到时间之后  取出：之前的小时 取字符串
        serveMin = "" ////拿到时间之后  取出：之后的分钟 取字符串
        return "";
      }
    },
    deviceStateComputed() {
      if (this.userControlData.openState === 1) {
        return "已打开";
      } else {
        return "已关闭";
      }
    },
    computerCycleConfigShow() {
      let cycleShow = "周 ";
      let count = 0;
      if (this.ServeOneObjectinfo.businessId3.indexOf("1") != -1) {
        cycleShow += "一 ";
        count++;
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf("2") != -1) {
        cycleShow += "二 ";
        count++;
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf("3") != -1) {
        cycleShow += "三 ";
        count++;
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf("4") != -1) {
        cycleShow += "四 ";
        count++;
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf("5") != -1) {
        cycleShow += "五 ";
        count++;
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf("6") != -1) {
        cycleShow += "六 ";
        count++;
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf("7") != -1) {
        cycleShow += "日 ";
        count++;
      }
      if (count >= 7) {
        cycleShow = "每天";
      }
      if (cycleShow === "周") {
        cycleShow = "";
      }
      return cycleShow;
    }
  },
  watch: {
    "objData.openState": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openState = val;
      }
    },
    "objData.openStateValue": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue = val;
      }
    }
  }
};
</script>

<style>
.device014_dimming_wraper {
  height: 400px;
}
.data014_show {
  margin-top: 20px;
  margin-bottom: 60px;
}
div .content022_wraper {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;

  height: 280px;
}
.device022_time_title {
  font-size: 16px;
  color: #f5f5f5;
  margin-top: 20px;
  /* display: inline-block; */
}
.device_022_time {
  font-size: 24px;
  color: #f5f5f5;
  margin-top: 0px;
  /* margin-bottom: 5px; */
  position: relative;
  width: 100%;
  text-align: center;
}
.device_022_time::after {
  content: "";
  display: inline-block;
  width: 280px;
  height: 1px;
  background-color: #666666;
  position: absolute;
  bottom: -5px;
  right: 9px;
}
.device_022_scene {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  position: relative;
}
.device_022_scene span {
  margin: 0px 10px;
}

.device_022_scene::after {
  content: "";
  display: inline-block;
  width: 280px;
  height: 1px;
  background-color: #666666;
  position: absolute;
  bottom: -5px;
  right: 10px;
}
div .device022_btn {
  margin-top: 40px;
  width: 260px;
}
.device_022_text_width {
  display: inline-block;
  width: 160px;

  text-align: right;
}
</style>
